
let wasm;

const heap = new Array(32).fill(undefined);

heap.push(undefined, null, true, false);

function getObject(idx) { return heap[idx]; }

let heap_next = heap.length;

function dropObject(idx) {
    if (idx < 36) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachegetUint8Memory0 = null;
function getUint8Memory0() {
    if (cachegetUint8Memory0 === null || cachegetUint8Memory0.buffer !== wasm.memory.buffer) {
        cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachegetUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

let WASM_VECTOR_LEN = 0;

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1);
    getUint8Memory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

let cachegetInt32Memory0 = null;
function getInt32Memory0() {
    if (cachegetInt32Memory0 === null || cachegetInt32Memory0.buffer !== wasm.memory.buffer) {
        cachegetInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachegetInt32Memory0;
}

function getArrayU8FromWasm0(ptr, len) {
    return getUint8Memory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedTextEncoder = new TextEncoder('utf-8');

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length);
        getUint8Memory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len);

    const mem = getUint8Memory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3);
        const view = getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}
/**
*/
export class EmulatorWrapper {

    static __wrap(ptr) {
        const obj = Object.create(EmulatorWrapper.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_emulatorwrapper_free(ptr);
    }
    /**
    * Create a new emulator wrapper
    * @returns {EmulatorWrapper}
    */
    static new() {
        var ret = wasm.emulatorwrapper_new();
        return EmulatorWrapper.__wrap(ret);
    }
    /**
    * Load ROM data to the emulator
    * @param {Uint8Array} rom_data
    */
    load_rom(rom_data) {
        var ptr0 = passArray8ToWasm0(rom_data, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.emulatorwrapper_load_rom(this.ptr, ptr0, len0);
    }
    /**
    * Load bootrom data to the emulator
    * @param {Uint8Array} bootrom_data
    */
    load_bootrom(bootrom_data) {
        var ptr0 = passArray8ToWasm0(bootrom_data, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.emulatorwrapper_load_bootrom(this.ptr, ptr0, len0);
    }
    /**
    * Set the emulator state to match the serialized save state
    * @param {Uint8Array} save_data
    */
    load_save(save_data) {
        var ptr0 = passArray8ToWasm0(save_data, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.emulatorwrapper_load_save(this.ptr, ptr0, len0);
    }
    /**
    * Returns a serialized emulator state for savefiles
    * @returns {Uint8Array}
    */
    save() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emulatorwrapper_save(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v0 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1);
            return v0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Returns the emulator f32 sound queue
    * @returns {Float32Array}
    */
    get_sound_queue() {
        var ret = wasm.emulatorwrapper_get_sound_queue(this.ptr);
        return takeObject(ret);
    }
    /**
    * Returns 0 for Render event, 1 for Sound Event
    * @returns {number}
    */
    run_until_frontend_event() {
        var ret = wasm.emulatorwrapper_run_until_frontend_event(this.ptr);
        return ret >>> 0;
    }
    /**
    * Returns the emulator screen bitmap
    * @returns {Uint8Array}
    */
    get_screen_bitmap() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emulatorwrapper_get_screen_bitmap(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v0 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1);
            return v0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Returns the name of currently loaded rom file
    * @returns {string}
    */
    get_rom_name() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emulatorwrapper_get_rom_name(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(r0, r1);
        }
    }
    /**
    * Set the name of currently loaded rom file
    * @param {string} romname
    */
    set_rom_name(romname) {
        var ptr0 = passStringToWasm0(romname, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.emulatorwrapper_set_rom_name(this.ptr, ptr0, len0);
    }
    /**
    */
    press_key_up() {
        wasm.emulatorwrapper_press_key_up(this.ptr);
    }
    /**
    */
    press_key_down() {
        wasm.emulatorwrapper_press_key_down(this.ptr);
    }
    /**
    */
    press_key_left() {
        wasm.emulatorwrapper_press_key_left(this.ptr);
    }
    /**
    */
    press_key_right() {
        wasm.emulatorwrapper_press_key_right(this.ptr);
    }
    /**
    */
    press_key_a() {
        wasm.emulatorwrapper_press_key_a(this.ptr);
    }
    /**
    */
    press_key_b() {
        wasm.emulatorwrapper_press_key_b(this.ptr);
    }
    /**
    */
    press_key_start() {
        wasm.emulatorwrapper_press_key_start(this.ptr);
    }
    /**
    */
    press_key_select() {
        wasm.emulatorwrapper_press_key_select(this.ptr);
    }
    /**
    */
    clear_key_up() {
        wasm.emulatorwrapper_clear_key_up(this.ptr);
    }
    /**
    */
    clear_key_down() {
        wasm.emulatorwrapper_clear_key_down(this.ptr);
    }
    /**
    */
    clear_key_left() {
        wasm.emulatorwrapper_clear_key_left(this.ptr);
    }
    /**
    */
    clear_key_right() {
        wasm.emulatorwrapper_clear_key_right(this.ptr);
    }
    /**
    */
    clear_key_a() {
        wasm.emulatorwrapper_clear_key_a(this.ptr);
    }
    /**
    */
    clear_key_b() {
        wasm.emulatorwrapper_clear_key_b(this.ptr);
    }
    /**
    */
    clear_key_start() {
        wasm.emulatorwrapper_clear_key_start(this.ptr);
    }
    /**
    */
    clear_key_select() {
        wasm.emulatorwrapper_clear_key_select(this.ptr);
    }
    /**
    * Serialize and turn the save data into a compact string representation
    * @returns {string}
    */
    save_as_str() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emulatorwrapper_save_as_str(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(r0, r1);
        }
    }
    /**
    * Turn the compact string representation into save data and deserialize
    * @param {string} string
    */
    load_save_str(string) {
        var ptr0 = passStringToWasm0(string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.emulatorwrapper_load_save_str(this.ptr, ptr0, len0);
    }
}

async function load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

async function init(input) {
    if (typeof input === 'undefined') {
        input = new URL('index_bg.wasm', import.meta.url);
    }
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbg_buffer_ebc6c8e75510eae3 = function(arg0) {
        var ret = getObject(arg0).buffer;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithbyteoffsetandlength_ab2b53c614369e0e = function(arg0, arg1, arg2) {
        var ret = new Float32Array(getObject(arg0), arg1 >>> 0, arg2 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_cc5264f47906c023 = function(arg0) {
        var ret = new Float32Array(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_memory = function() {
        var ret = wasm.memory;
        return addHeapObject(ret);
    };

    if (typeof input === 'string' || (typeof Request === 'function' && input instanceof Request) || (typeof URL === 'function' && input instanceof URL)) {
        input = fetch(input);
    }



    const { instance, module } = await load(await input, imports);

    wasm = instance.exports;
    init.__wbindgen_wasm_module = module;

    return wasm;
}

export default init;

